import { z } from 'zod'
import { EndDate, Id, IsActive, StartDate, UpdateDate } from './common-schemas'
import { GarItem } from './gar-item'

export namespace ApartmentType {
  export interface Data {
    /** @description Type identifier (key) */
    readonly id: number

    /** @description Name */
    readonly name: string

    /** @description Short name */
    readonly shortName?: string

    /** @description Description */
    readonly description?: string

    /** @description Record entry (update) date */
    readonly updatedDate: Date

    /** @description Record validity start */
    readonly startDate: Date

    /** @description Record validity end */
    readonly endDate: Date

    /** @description Activity status */
    readonly isActive: boolean
  }
}

/** @description Information about apartment types */
export class ApartmentType extends GarItem<
  'ApartmentType',
  ApartmentType.Data
> {
  static readonly SCHEMA: GarItem.Schema<ApartmentType.Data> = z
    .strictObject({
      ID: Id,

      NAME: z.string().describe('Name'),

      SHORTNAME: z.string().optional().describe('Short name'),

      DESC: z.string().optional().describe('Description'),

      UPDATEDATE: UpdateDate,

      STARTDATE: StartDate,

      ENDDATE: EndDate,

      ISACTIVE: IsActive,
    })
    .transform<ApartmentType.Data>(attributes => ({
      id: attributes.ID,
      name: attributes.NAME,
      shortName: attributes.SHORTNAME,
      description: attributes.DESC,
      updatedDate: attributes.UPDATEDATE,
      startDate: attributes.STARTDATE,
      endDate: attributes.ENDDATE,
      isActive: attributes.ISACTIVE,
    }))

  readonly type = 'ApartmentType'

  protected get schema() {
    return ApartmentType.SCHEMA
  }
}
